export default "__VITE_PUBLIC_ASSET__1a0519d2__"